<script>
import axios from "axios";

import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
let user = JSON.parse(localStorage.getItem("user"));

/**
 * Register component
 */
export default {
  page: {
    title: "Sửa dịch vụ gửi tiền",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      items: [
        {
          text: "Trang Chủ",
          href: "/",
        },
          {
          text: "Dịch vụ",
          href: "/danh-sach-dich-vu",
        },
        {
          text: "Sửa dịch vụ gửi tiền",
          active: true,
        },
      ],

      service: {
        name: "Dịch vụ gửi tiền",
        type: 1,
        money: [
          {
            name: "Sài gòn", // tỉnh thành gửi
            price: 1.99, // giá phí
            unit: "$", // đơn vị tính
            money_min: 100, // số tiền nhỏ nhất để gửi
            provinces: [],
          },
          {
            name: "Hà nội", // tỉnh thành gửi
            price: 0.99, // giá phí
            unit: "$", // đơn vị tính
            money_min: 100, // số tiền nhỏ nhất để gửi
            provinces: ["Hà nội", "Nghệ an"],
          },
        ],
      },
      submitted: false,
    };
  },
  computed: {
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  methods: {
    // Try to register the service in with the email, name
    // and password they provided.

    tryToUpdateIn() {
      this.submitted = true;

      // stop here if form is invalid
      axios({
        url: process.env.VUE_APP_SERVER_URL + "/service/update",
        method: "post",
        headers: {
          authorization: user.token,
        },

        data: this.service,
      })
        .then(({ data }) => {
          this.$toasted.success("Sửa dịch vụ thành công");
        })
        .catch((error) => {
          this.$toasted.error("Sửa dịch vụ có lỗi");
        });
    },
  },

  created() {
    if (!this.$route.query.id) {
      this.$router.push("/");
    }
    let seft = this;
    let _id = this.$route.query.id;

    axios({
      url: process.env.VUE_APP_SERVER_URL + "/service/info",
      method: "post",
      headers: {
        authorization: user.token,
      },

      data: {
        _id: _id,
      },
    })
      .then(({ data }) => {
        if (data) {
          console.log(data);
          this.service = data;
        } else {
          this.$toasted.error("Không tìm thấy dịch vụ phù hợp");
          this.$router.push("/");
        }
      })
      .catch((err) => {
        console.log(err);
        this.$toasted.error("Không tìm thấy dịch vụ phù hợp");
        // this.$router.push("/");
      });
  },
};
</script>
<style>
.b-form-tag-content {
  border: 1px solid #e5e5e5;
  background: #f8f9fa;
  color: #000;
  border-radius: 2px;
  padding: 5px;
  text-transform: capitalize;
}

.b-form-tag-remove {
  border: 0px;
  margin-left: 2px;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row justify-content-center">
      <div class="col-md-12 col-lg-12 col-xl-12">
        <div class="card overflow-hidden">
          <div class="card-body pt-0">
            <b-form class="my-2 p-2" @submit.prevent="tryToUpdateIn">
              <b-form-group
                class="mb-3"
                id="service-name"
                label="Tên dịch vụ"
                label-for="name"
              >
                <b-form-input
                  v-model="service.name"
                  type="text"
                  debounce="1000"
                  placeholder="Nhập tên"
                  aria-required=""
                ></b-form-input>
              </b-form-group>
              <div
                class="px-3"
                v-for="(money, index) in service.money"
                :key="money.name + money.type + index"
              >
                <b-row>
                  <b-col class="md-3">
                    <b-form-group
                      class="mb-3"
                      :label="'Tùy chọn ' + (index + 1)"
                      label-for="provide"
                    >
                      <b-form-input
                        v-model="money.name"
                        debounce="1000"
                        type="text"
                        placeholder="Nhập tên"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col class="md-3">
                    <b-form-group
                      class="mb-3"
                      label="Giá"
                      label-for="service-money-name"
                    >
                      <b-form-input
                        v-model="money.price"
                        debounce="1000"
                        type="number"
                        step="0.01"
                        min="0.00"
                        max="1000000.00"
                        :placeholder="'Nhập giá của ' + money.name"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col>
                    <b-form-group>
                      <span>Tối thiểu </span>
                      <div class="py-2">
                        <b-form-input
                          v-model="money.money_min"
                          debounce="500"
                          type="number"
                          step="0.01"
                          min="0.00"
                          max="1000000.00"
                          placeholder="Nhập dữ liệu"
                        ></b-form-input>
                      </div>
                    </b-form-group>
                  </b-col>

                  <b-col>
                    <b-form-group>
                      <span>Giảm giá </span>
                      <div class="py-2">
                        <b-form-input
                          v-model="money.disc"
                          debounce="500"
                          type="number"
                          step="0.01"
                          min="0.00"
                          max="1000000.00"
                          placeholder="Nhập dữ liệu"
                        ></b-form-input>
                      </div>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group>
                      <span>Đơn vị giảm giá</span>
                      <div class="py-2">
                        <b-form-select
                          class="form-control"
                          v-model="money.disc_unit"
                          size="md"
                          :options="['$', '%']"
                        ></b-form-select>
                      </div>
                    </b-form-group>
                  </b-col>
                    <b-col>
                    <b-form-group>
                      <span>% nhân viên</span>
                      <div class="py-2">
                        <b-form-input
                          v-model="money.salary"
                          debounce="500"
                          type="number"
                          step="0.01"
                          min="0.00"
                          max="1000000.00"
                          placeholder="Nhập dữ liệu"
                        ></b-form-input>
                      </div>
                    </b-form-group>
                  </b-col>
                  <!-- <b-col class="md-3">
                    <b-form-group>
                      <span>Tính giá theo </span> {{ money.unit }}
                      <div class="py-2">
                        <b-form-select
                          class="px-2 form-control"
                          v-model="money.unit"
                          size="md"
                          :options="['$', '%']"
                        ></b-form-select>
                      </div>
                    </b-form-group>
                  </b-col> -->
                </b-row>

                <div class="px-5 pb-2" v-if="money.provinces">
                  <label for="tags-basic">Các tỉnh thành cùng giá</label>
                  <b-form-tags
                    separator=",;"
                    no-add-on-enter
                    input-id="tags-basic"
                    debounce="1000"
                    v-model="money.provinces"
                    placeholder="add Province"
                  ></b-form-tags>
                </div>
              </div>
              <div class="mt-4 d-grid">
                <b-button type="submit" variant="primary" class="btn-block"
                  >Sửa dịch vụ</b-button
                >
              </div>
            </b-form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>